import { createContext } from "react";

/** Set by a note view: internal links in rendered Markdown open in its side panel, with the text around them. */
export const LinkOpenerContext = createContext<((href: string, context: string) => void) | null>(null);

/** Link types shown in the side panel (others open in a tab, as before). */
export const PANEL_LINK_TYPES = new Set(["note", "paper", "cite", "task", "file"]);
